import * as R from 'ramda';
import * as P from 'plow-js';
import { handleActions } from 'redux-actions';
// component report-format-panel
import {
  addUsedReportRoutine,
  fetchReportsListData,
  editUsedReportRoutine,
  changeUsedReportRoutine,
  deleteUsedReportRoutine,
} from './routines';
//////////////////////////////////////////////////

export const initialState = {
  usedReport: {},
  availableReports: [],
};

const deleteUsedReportSuccess = state => P.$set('usedReport', {}, state);

const addOrEditUsedReportSuccess = (state, { payload }) => R.mergeLeft(payload, state);

const setUsedReportSuccess = (state, { payload }) => P.$set('usedReport', payload, state);

const setFetchReportsListSuccess = (state, { payload }) => P.$set('availableReports', payload, state);

export default handleActions(
  {
    [changeUsedReportRoutine.SUCCESS]: setUsedReportSuccess,
    [deleteUsedReportRoutine.SUCCESS]: deleteUsedReportSuccess,
    [addUsedReportRoutine.SUCCESS]: addOrEditUsedReportSuccess,
    [fetchReportsListData.SUCCESS]: setFetchReportsListSuccess,
    [editUsedReportRoutine.SUCCESS]: addOrEditUsedReportSuccess,
  },
  initialState,
);
